import * as BABYLONGUI from 'babylonjs-gui';

export function centerAssetTagText(control: BABYLONGUI.Container, annotationType: AnnotationType): void {
    if (annotationType !== AnnotationType.AssetTag && annotationType !== AnnotationType.AssetTagWithBox) return;
    if (!(control instanceof BABYLONGUI.Rectangle) || control.children.length !== 1) return;

    const text = control.children[0];
    if (!(text instanceof BABYLONGUI.TextBlock) || !text.resizeToFit) return;

    // The parent shape clips the label; allow glyphs to move within its padding.
    text.clipContent = false;
    text.onBeforeDrawObservable.add(() => {
        if (text.lines?.length !== 1) return;
        const context = text.host.getContext();
        const metrics = context.measureText(text.lines[0].text);
        const { ascent, descent } = text.fontOffset;
        // Center the visible glyphs, including font side bearings and the unused descender space.
        const x = (text.lines[0].width + metrics.actualBoundingBoxLeft - metrics.actualBoundingBoxRight) / 2;
        const y = (metrics.actualBoundingBoxAscent - metrics.actualBoundingBoxDescent - ascent + descent) / 2;
        if (Number.isFinite(x) && Number.isFinite(y)) {
            context.translate(control.centerX - text.centerX + x, control.centerY - text.centerY + y);
        }
    });
}
